import React, { Component } from "react";
import { Container } from "reactstrap";

import Jumbo from "../Helper/Jumbo";
import Documents from "../Helper/Documents";

class MidCap extends Component {
  constructor(props) {
    super(props);
    this.title = "Mid Cap Growth Mutual Fund";
    this.ticker = "I: IMIDX | R: CMIDX";
    this.objective = "Long-term Capital Growth";
    this.descriptions = [
      [
        "Overview ",
        "The fund invests in a portfolio of 35-45 established growth companies. Investments are predicated on a company’s future prospects rather than economic or market cycles. We value consistent profitable growth versus a growth now, profits later approach.",
      ],
      [
        "Approach ",
        "The fund employs a bottom-up, fundamental investment approach to uncover high-quality, durable growth franchise companies. The Fund seeks companies that offer attractive long-term growth and profitability prospects while trading at reasonble valuations.",
      ],
      [
        "Our Difference",
        "Investing in companies positioned for growth coupled with risk management techniques may provide the foundation to build a high conviction portfolio with consistent return generation and lower realized volatility.",
      ],
    ];

    this.pdfs = [
      ["/Mid Cap/mid-cap-growth-fact-card"],
      ["/Mid Cap/mid-cap-growth-fund-holdings"],
      ["/Mid Cap/congress-mid-cap-growth-fund(7.31.2026)"],
      ["/Mid Cap/congress-mid-cap-growth-fund(1.31.2026)"],
      ["/Mid Cap/congress_midcap_summary_prospectus"],
      ["/All/congress_statutory_prospectus"],
      ["/All/congress_sai"],
      ["/All/Congress Funds SemiAnnual Financial Statements and Additional Information 4.30.2026"],
      ["/Mid Cap/Congress Mid Cap Growth Institutional Class TSR SemiAnnual 4.30.2026"],
      ["/Mid Cap/Congress Mid Cap Growth Retail Class TSR SemiAnnual 4.30.2026"],
      ["/Mid Cap/Congress Mid Cap Growth Fund Institutional Class 10.31.25 TSR"],
      ["/Mid Cap/Congress Mid Cap Growth Fund Retail Class 10.31.25 TSR"],
      ["/All/Annual Financial Statements and Additional Information 2025"],
      ["/All/2026 Capital Gains Flyer"],

    ];
    this.docNames = [
      "FACT SHEET",
      "HOLDINGS",
	"COMPLETE MID CAP GROWTH HOLDINGS - 7/31/2026",
	"COMPLETE MID CAP GROWTH HOLDINGS - 1/31/2026",
      "SUMMARY OF PROSPECTUS",
      "PROSPECTUS",
      "STATEMENT OF ADDITIONAL INFORMATION",
      "SEMI-ANNUAL FINANCIAL STATEMENTS AND ADDITIONAL INFORMATION",
      "SEMI-ANNUAL SHAREHOLDER REPORT - INST CLASS",
      "SEMI-ANNUAL SHAREHOLDER REPORT - RETAIL CLASS",
      "ANNUAL SHAREHOLDER REPORT - INST CLASS",
      "ANNUAL SHAREHOLDER REPORT - RETAIL CLASS",
      "ANNUAL FINANCIAL STATEMENTS AND ADDITIONAL INFORMATION",
      "2026 CAPITAL GAINS ESTIMATES",
    ];
  }

  render() {
    return (
      <Container fluid>
        <Jumbo
          title={this.title}
          ticker={this.ticker}
          objective={this.objective}
          descriptions={this.descriptions}
        />
        <Documents pdfs={this.pdfs} docs={this.docNames} />
			
								<p style={{paddingLeft: "9%",paddingRight: "9%",paddingTop: "10px",paddingBottom: "2%",fontWeight: "bold"}}>Mutual Fund investing involves risk. Principal Loss is possible. The Fund may invest in foreign securities which involve greater volatility and political, economic and currency risks and differences in accounting methods. Investing in small and medium-sized companies involves greater risks than those associated with investing in large company stocks, such as business risk, significant stock price fluctuations and illiquidity. Growth stocks can perform differently from the market as a whole and from other types of stocks. Growth stocks tend to be sensitive to changes in the earnings of their underlying companies and more volatile than other types of stocks, particularly over the short term.

</p>	
	
		
      </Container>
    );
  }
}

export default MidCap;
